import { Link, Route, Routes } from "react-router-dom";

import { Layout } from "./components/Layout";
import { Home } from "./screens/Home";
import { Library } from "./screens/Library";
import { SearchScreen } from "./screens/SearchScreen";
import { SpeakerDetail, SpeakersIndex } from "./screens/Speakers";
import { ThemeDetail, ThemesIndex } from "./screens/Themes";
import { VideoScreen } from "./screens/VideoScreen";

function NotFound() {
  return (
    <p className="text-warm-gray">
      This page does not exist.{" "}
      <Link to="/" className="text-terra hover:underline">
        Back to the start
      </Link>
      .
    </p>
  );
}

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/library" element={<Library />} />
        <Route path="/search" element={<SearchScreen />} />
        <Route path="/video/:id" element={<VideoScreen />} />
        <Route path="/themes" element={<ThemesIndex />} />
        <Route path="/themes/:key" element={<ThemeDetail />} />
        <Route path="/speakers" element={<SpeakersIndex />} />
        <Route path="/speakers/:key" element={<SpeakerDetail />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
